/// <reference path="../_references.ts"/>

module App.Administrative.Inventory {
    import ServiceRequest = App.Appointments.ServiceRequest;
    import Appointment = App.Appointments.Appointment;

    export class InventoryService {
        constructor(
            private $http: ng.IHttpService,
            public Constants: IConstants
        ){

        }

        getServiceRequest(serviceRequestID: number): ng.IHttpPromise<ServiceRequest> {
            return this.$http.get(`${this.Constants.apiUrl}servicerequest/${serviceRequestID}`);
        }

        getAllInventoryReplenishments(): ng.IHttpPromise<InventoryReplenishment[]> {
            return this.$http.get(`${this.Constants.apiUrl}inventoryreplenishment`);
        }

        getInventoryReplenishment(apptID: number): ng.IHttpPromise<InventoryReplenishment[]> {
            return this.$http.get(`${this.Constants.apiUrl}appointment/${apptID}/inventory`);
        }

        createInventoryReplenishment(apptID: number, invRepl: InventoryReplenishmentCreate): ng.IHttpPromise<InventoryReplenishment> {
            return this.$http.post(`${this.Constants.apiUrl}appointment/${apptID}/inventory`, invRepl);
        }

        createIndependentInventoryReplenishment(invRepl: InventoryReplenishmentCreate): ng.IHttpPromise<InventoryReplenishment> {
            return this.$http.post(`${this.Constants.apiUrl}inventoryreplenishment`, invRepl);
        }

        deleteInventoryReplenishment(invReplID: number): ng.IHttpPromise<InventoryReplenishment> {
            return this.$http.delete(`${this.Constants.apiUrl}inventoryreplenishment/${invReplID}`);
        }

        getInventoryList(searchParams: SearchParams): ng.IHttpPromise<InventoryDetails[]> {
            return this.$http.get(`${this.Constants.apiUrl}inventory`, {
                params: searchParams
            });
        }

        getInventoryItem(invId: number): ng.IHttpPromise<InventoryDetails> {
            return this.$http.get(`${this.Constants.apiUrl}inventory/${invId}`);
        }

        favoriteInventory(invId: number): ng.IHttpPromise<InventoryDetails> {
            return this.$http.post(`${this.Constants.apiUrl}inventory/${invId}/favorite`, {});
        }

        unfavoriteInventory(invId: number): ng.IHttpPromise<InventoryDetails> {
            return this.$http.post(`${this.Constants.apiUrl}inventory/${invId}/unfavorite`, {});
        }

        createCustomInventory(customInventory: CustomInventory): ng.IHttpPromise<InventoryDetails> {
            return this.$http.post(`${this.Constants.apiUrl}inventory`, customInventory);
        }

        getInventoryGroups(): ng.IHttpPromise<InventoryGroup[]>  {
            return this.$http.get(`${this.Constants.apiUrl}inventorygroup`);
        }

        getWarehouses(): ng.IHttpPromise<Warehouse[]>  {
            return this.$http.get(`${this.Constants.apiUrl}warehouse`);
        }

        getInventoryCategories(setId: number): ng.IHttpPromise<InventoryCategory[]>  {
            return this.$http.get(`${this.Constants.apiUrl}inventorycategory?inventory_group=${setId}`)
        }

        getInventorySubCategories(categoryId: number): ng.IHttpPromise<InventorySubCategory[]>  {
            return this.$http.get(`${this.Constants.apiUrl}inventorysubcategory?category=${categoryId}`);
        }

        public static Factory() {
            let instance = ($http: ng.IHttpService, Constants: IConstants) => {
                return new InventoryService($http, Constants);
            };

            instance.$inject = ['$http', 'Constants'];

            return instance;
        }
    }
}